import styled from 'styled-components';

const Icon = styled.div`
  max-width: 10rem;
`;

export default Icon;
